export type PropertyDetailsNavigationOptions = {
  tab?: string;
  autoAction?: string;
  from?: string;
};

export function buildPropertyDetailsUrl(propertyId: string, options: PropertyDetailsNavigationOptions = {}): string {
  const params = new URLSearchParams({ property: propertyId });

  if (options.tab) {
    params.set('tab', options.tab);
  }

  if (options.autoAction) {
    params.set('autoAction', options.autoAction);
  }

  if (options.from) {
    params.set('from', options.from);
  }

  return `/properties/detail/?${params.toString()}`;
}